module.exports = __webpack_public_path__ + "img/building-04.0c880826.svg";